export default __webpack_public_path__ + "static/image16-7d1fa1fadc3daf288dcda5c1db9a2000.gif";